import React from 'react';
import styled, { keyframes } from 'styled-components';
import useAuthRedirect from '../hooks/useAuthRedirect';
import { useChat } from '../context/ChatProvider';

const gradientShift = keyframes`
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const WrapperContainer = styled.div`
  display: grid;
  height: 100vh;
  place-items: center;
  overflow-x: hidden;
  overflow-y: ${props => props.enableScrolling ? 'auto' : 'hidden'};
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  background-size: 200% 200%;
  animation: ${gradientShift} 15s ease infinite;
`;

const ChatAppContainer = styled.div`
  --vertical-padding: 2.1vh;

  display: flex;
  height: 94vh;
  width: 94vw;
  max-width: 1400px;
  justify-content: space-between;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);

  @media (max-width: 820px) {
    position: relative;
    width: 100%;
    height: 100vh;
    flex-direction: column-reverse;
    font-size: 0.85rem;
    gap: 0;
    border-radius: 0;
    border: none;
  }
`;

const Wrapper = ({ children, authCheck = true, restrictGuest = false, enableScrolling = true }) => {
    useAuthRedirect({ authCheck, restrictGuest });
    const { isTextareaFocused, setIsNavOpen, isNavOpen } = useChat();

    return (
        <WrapperContainer enableScrolling={enableScrolling}>
            <ChatAppContainer>
                {children}
            </ChatAppContainer>
        </WrapperContainer>
    );
};

export default Wrapper;
